import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Flex, FormField, TextInput } from '@percent/lemonade'
import { Card } from '@percent/product-nomination-form/ui/Card/Card'
import {
  usePartnerConfig,
  useProgress,
} from '@percent/product-nomination-form/hooks'
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'
import { HostedFormStep } from '../../HostedForm.types'
import { SubmitNominationFormPayload } from '@percent/product-nomination-form/api/nominationForm/nominationForm.types'

export const NominatorDetails = () => {
  const { t } = useTranslation()
  const { progress } = useProgress()
  const { handleNext } = useValidationStepData()
  const { partnerConfig } = usePartnerConfig()
  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<SubmitNominationFormPayload>()

  const fullName = watch('nominator.fullName')
  const email = watch('nominator.email')

  const isNextDisabled =
    !fullName ||
    !email ||
    !!errors.nominator?.fullName ||
    !!errors.nominator?.email

  return (
    <Card
      title={t('hostedValidation.nominatorDetails.title')}
      description={t('hostedValidation.nominatorDetails.description')}
      onNext={() => handleNext(HostedFormStep.ORGANISATION_ORIGIN)}
      nextButtonDisabled={isNextDisabled}
      progress={progress}
      nextButtonLabel={t('hostedValidation.button.next')}
    >
      <Flex direction="column" gap={16} w="100%">
        <FormField
          label={t('hostedValidation.nominatorDetails.fullName')}
          status={errors.nominator?.fullName?.message ? 'danger' : 'default'}
          necessity="required"
          statusMessage={errors.nominator?.fullName?.message}
        >
          <TextInput
            {...register('nominator.fullName')}
            placeholder={t(
              'hostedValidation.nominatorDetails.fullNamePlaceholder'
            )}
          />
        </FormField>
        <FormField
          label={t('hostedValidation.nominatorDetails.email')}
          status={errors.nominator?.email?.message ? 'danger' : 'default'}
          necessity="required"
          statusMessage={errors.nominator?.email?.message}
          description={t('hostedValidation.nominatorDetails.emailDescription', {
            partner: partnerConfig?.configuration.partner.name,
          })}
        >
          <TextInput
            {...register('nominator.email')}
            placeholder={t(
              'hostedValidation.nominatorDetails.emailPlaceholder'
            )}
          />
        </FormField>
      </Flex>
    </Card>
  )
}
